var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { DEFAULT_APP_NAME } from '../index';
import { useFirebaseApp } from '.';
import * as firebase from 'firebase/app';

function importSDK(sdk) {
  switch (sdk) {
    case 'analytics':
      return import('firebase/analytics');

    case 'auth':
      return import('firebase/auth');

    case 'database':
      return import('firebase/database');

    case 'firestore':
      return import('firebase/firestore');

    case 'functions':
      return import('firebase/functions');

    case 'messaging':
      return import('firebase/messaging');

    case 'performance':
      return import('firebase/performance');

    case 'remoteConfig':
      return import('firebase/remote-config');

    case 'storage':
      return import('firebase/storage');
  }
}

function proxyComponent(componentName) {
  var contextualApp;

  var useComponent = function useComponent() {
    contextualApp = useFirebaseApp();

    if (!firebase[componentName]) {
      throw importSDK(componentName);
    }

    return firebase[componentName];
  };

  return new Proxy(useComponent, {
    get: function get(target, p) {
      return target()[p];
    },
    apply: function apply(target, _this, args) {
      var component = target().bind(_this);

      if (!args[0]) {
        args[0] = contextualApp;
      }

      return component.apply(void 0, args);
    }
  });
}

export var useAuth = proxyComponent('auth');
export var useAnalytics = proxyComponent('analytics');
export var useDatabase = proxyComponent('database');
export var useFirestore = proxyComponent('firestore');
export var useFunctions = proxyComponent('functions');
export var useMessaging = proxyComponent('messaging');
export var usePerformance = proxyComponent('performance');
export var useRemoteConfig = proxyComponent('remoteConfig');
export var useStorage = proxyComponent('storage');
export var auth = useAuth;
export var analytics = useAnalytics;
export var database = useDatabase;
export var firestore = useFirestore;
export var functions = useFunctions;
export var messaging = useMessaging;
export var performance = usePerformance;
export var remoteConfig = useRemoteConfig;
export var storage = useStorage;

function preload(componentName) {
  var _this_1 = this;

  return function (firebaseApp, settingsCallback) {
    return __awaiter(_this_1, void 0, void 0, function () {
      var app, initialized, instanceFactory;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            app = firebaseApp || useFirebaseApp();
            initialized = !!app[componentName];
            if (!!initialized) return [3, 2];
            return [4, importSDK(componentName)];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            instanceFactory = app[componentName].bind(app);
            if (!initialized) return [3, 3];

            if (settingsCallback) {
              console.warn(componentName + " was already initialized on " + (app.name == DEFAULT_APP_NAME ? 'the default app' : app.name) + ", ignoring settingsCallback");
            }

            return [3, 5];

          case 3:
            if (!settingsCallback) return [3, 5];
            return [4, Promise.resolve(settingsCallback(instanceFactory))];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            return [2, instanceFactory];
        }
      });
    });
  };
}

export var preloadAuth = preload('auth');
export var preloadAnalytics = preload('analytics');
export var preloadDatabase = preload('database');
export var preloadFirestore = preload('firestore');
export var preloadFunctions = preload('functions');
export var preloadMessaging = preload('messaging');
export var preloadPerformance = preload('performance');
export var preloadRemoteConfig = preload('remoteConfig');
export var preloadStorage = preload('storage');